import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ChatSource {
  title: string;
  slug: string;
  category: string;
  section?: string;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  sources: ChatSource[];
  followUp: string[];
  confidence?: number;
  isError?: boolean;
}

export interface AskResponse {
  answer: string;
  sources: ChatSource[];
  followUp: string[];
  confidence: number;
}

@Injectable({
  providedIn: 'root'
})
export class KbChatbotService {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    // In dev: /api/kb-api (proxied via proxy.conf.json to localhost:3001)
    // In prod: /api/kb-api (proxied via backend to kb-service)
    this.baseUrl = environment.kbServiceUrl || '/api/kb-api';
  }

  ask(question: string, currentPage?: string): Observable<AskResponse> {
    return this.http.post<AskResponse>(`${this.baseUrl}/ask`, {
      question,
      context: currentPage ? { currentPage } : undefined
    });
  }
}
